import { render, staticRenderFns } from "./batch-uploader.vue?vue&type=template&id=11abffec&scoped=true&"
import script from "./batch-uploader.vue?vue&type=script&lang=ts&"
export * from "./batch-uploader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11abffec",
  null
  
)

export default component.exports